module.exports = __webpack_public_path__ + "img/icon-navigation-main.53d95f57.svg";